import { createRoute } from '@tanstack/react-router'
import { appShellRoute } from '@/app/routes/_appShell'
import { validateChannelOnly } from '@/app/routes/_search'
import { AtlasPage } from '@/features/factory/pages/AtlasPage'
import { CodeLevelsPage } from '@/features/factory/pages/CodeLevelsPage'
import { CortesPage } from '@/features/factory/pages/CortesPage'
import { EtymologyPage } from '@/features/factory/pages/EtymologyPage'
import { FactoryComingSoonPage } from '@/features/factory/pages/FactoryComingSoonPage'
import { FactoryPage } from '@/features/factory/pages/FactoryPage'
import { FootballPage } from '@/features/factory/pages/FootballPage'
import { MiragePage } from '@/features/factory/pages/MiragePage'
import { NasaApodPage } from '@/features/factory/pages/NasaApodPage'
import { ProductReviewPage } from '@/features/factory/pages/ProductReviewPage'
import { QuizPage } from '@/features/factory/pages/QuizPage'
import { RankedPage } from '@/features/factory/pages/RankedPage'
import { RedditStoriesPage } from '@/features/factory/pages/RedditStoriesPage'
import { ViralShortsPage } from '@/features/factory/pages/ViralShortsPage'

export const factoryRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory',
  validateSearch: validateChannelOnly,
  component: FactoryPage,
})

export const factoryViralRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/viral-shorts',
  validateSearch: validateChannelOnly,
  component: ViralShortsPage,
})

export const factoryAtlasRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/atlas',
  validateSearch: validateChannelOnly,
  component: AtlasPage,
})

export const factoryProductRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/product-review',
  validateSearch: validateChannelOnly,
  component: ProductReviewPage,
})

export const factoryFootballRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/football',
  validateSearch: validateChannelOnly,
  component: FootballPage,
})

export const factoryApodRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/nasa-apod',
  validateSearch: validateChannelOnly,
  component: NasaApodPage,
})

export const factoryMirageRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/mirage',
  validateSearch: validateChannelOnly,
  component: MiragePage,
})

export const factoryPovLivesRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/pov-lives',
  validateSearch: validateChannelOnly,
  component: () => (
    <FactoryComingSoonPage
      title="POV Lives"
      description="Pausada até termos LLM + geração de imagem rodando local — Pollinations free é gargalo (>20min em stills) e HF paid não compensa hoje."
    />
  ),
})

export const factoryQuizRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/quiz',
  validateSearch: validateChannelOnly,
  component: QuizPage,
})

export const factoryRedditStoriesRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/reddit-stories',
  validateSearch: validateChannelOnly,
  component: RedditStoriesPage,
})

export const factoryEtymologyRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/etymology',
  validateSearch: validateChannelOnly,
  component: EtymologyPage,
})

export const factoryRankedRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/ranked',
  validateSearch: validateChannelOnly,
  component: RankedPage,
})

export const factoryCodeLevelsRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/code-levels',
  validateSearch: validateChannelOnly,
  component: CodeLevelsPage,
})

export const factoryCortesRoute = createRoute({
  getParentRoute: () => appShellRoute,
  path: '/factory/cortes',
  validateSearch: validateChannelOnly,
  component: CortesPage,
})

/** Single import surface for the router tree. */
export const factoryRoutes = [
  factoryRoute,
  factoryViralRoute,
  factoryAtlasRoute,
  factoryProductRoute,
  factoryFootballRoute,
  factoryApodRoute,
  factoryMirageRoute,
  factoryPovLivesRoute,
  factoryQuizRoute,
  factoryRedditStoriesRoute,
  factoryEtymologyRoute,
  factoryRankedRoute,
  factoryCodeLevelsRoute,
  factoryCortesRoute,
] as const
